
export function attachDisposableEvent(f, node, eventType) {
    node.addEventListener(eventType, f);
    return {
        Dispose() {
            node.removeEventListener(eventType, f);
        },
    };
}

